import { createReducer, on } from '@ngrx/store';
import { Event } from '../../models';
import * as pageActions from '../actions/events.action';
import { ToEntities } from '@teamfoster/sdk/array-utility';
import { PageData } from 'src/app/standalone/models/page-data.model';

export interface EventsState {
  entities: { [id: string]: Event };
  page: PageData;
  loaded: string[];
  loading: string[];
  overviewLoaded: boolean;
  overviewLoading: boolean;
  error?: any;
}

export const initialState: EventsState = {
  entities: {},
  page: { currentPage: 0, pageCount: 0, resultCount: 0, pageSize: 25, filters: {} },
  loaded: [],
  loading: [],
  overviewLoaded: false,
  overviewLoading: false,
};

export const EventsReducer = createReducer(
  initialState,

  on(pageActions.LoadEventsOverview, (state: EventsState) => {
    return {
      ...state,
      overviewLoading: true,
    };
  }),
  on(pageActions.LoadEventsOverviewSuccess, (state: EventsState, { events }) => {
    const entities = ToEntities(events.items, 'trackingKey', {});

    return {
      ...state,
      entities,
      page: events.page,
      overviewLoading: false,
      overviewLoaded: true,
    };
  }),
  on(pageActions.LoadMoreEvents, (state: EventsState) => {
    return {
      ...state,
      overviewLoading: true,
    };
  }),
  on(pageActions.LoadMoreEventsSuccess, (state: EventsState, { events }) => {
    const entities = ToEntities(events.items, 'trackingKey', state.entities);
    return {
      ...state,
      entities,
      page: events.page,
      overviewLoading: false,
      overviewLoaded: true,
    };
  }),
  on(pageActions.LoadEventsOverviewFail, (state: EventsState, { error }) => {
    return {
      ...state,
      overviewLoading: false,
      overviewLoaded: false,
      error,
    };
  }),
  on(pageActions.LoadEventById, (state: EventsState, { id }) => {
    return {
      ...state,
      loading: [...state.loading, `${id}`],
    };
  }),
  on(pageActions.LoadEventByIdSuccess, (state: EventsState, { item }) => {
    const entities = { ...state.entities, [item.trackingKey]: item };
    return {
      ...state,
      entities,
      loading: state.loading.filter(id => id !== `${item.id}`),
      loaded: [...state.loaded, item.trackingKey],
    };
  }),
  on(pageActions.LoadEventByIdFail, (state: EventsState, { error, id }) => {
    return {
      ...state,
      loading: state.loading.filter(id => id !== id),
      loaded: state.loaded.filter(id => id !== id),
      error,
    };
  })
);

export const getEventsEntities = (state: EventsState) => state.entities;
export const getEventsLoading = (state: EventsState) => state.loading;
export const getEventsLoaded = (state: EventsState) => state.loaded;
export const getEventsOverviewLoading = (state: EventsState) => state.overviewLoading;
export const getEventsOverviewLoaded = (state: EventsState) => state.overviewLoaded;
export const getEventsPage = (state: EventsState) => state.page;
export const getEventError = (state: EventsState) => state.error;
